export const NEPAL_SOURCE_AUTHORITY_IDS = Object.freeze([
    'NEPAL_LAW_COMMISSION',
    'MINISTRY_OF_FINANCE_NEPAL',
    'INLAND_REVENUE_DEPARTMENT_NEPAL',
    'SEBON',
    'NEPSE',
    'CDSC',
    'NEPAL_RASTRA_BANK',
    'ACCOUNTING_STANDARDS_BOARD_NEPAL',
    'ICAN',
    'FIU_NEPAL',
]);
export const NEPAL_SOURCE_AUTHORITIES = Object.freeze([
    { id: 'NEPAL_LAW_COMMISSION', name: 'Nepal Law Commission', authorityType: 'LAW', officialPublicationRequired: true },
    { id: 'MINISTRY_OF_FINANCE_NEPAL', name: 'Ministry of Finance, Nepal', authorityType: 'LAW', officialPublicationRequired: true },
    { id: 'INLAND_REVENUE_DEPARTMENT_NEPAL', name: 'Inland Revenue Department, Nepal', authorityType: 'REGULATOR', officialPublicationRequired: true },
    { id: 'SEBON', name: 'Securities Board of Nepal', authorityType: 'REGULATOR', officialPublicationRequired: true },
    { id: 'NEPSE', name: 'Nepal Stock Exchange', authorityType: 'MARKET', officialPublicationRequired: true },
    { id: 'CDSC', name: 'CDS and Clearing Limited', authorityType: 'DEPOSITORY', officialPublicationRequired: true },
    { id: 'NEPAL_RASTRA_BANK', name: 'Nepal Rastra Bank', authorityType: 'REGULATOR', officialPublicationRequired: true },
    { id: 'ACCOUNTING_STANDARDS_BOARD_NEPAL', name: 'Accounting Standards Board Nepal', authorityType: 'ACCOUNTING_STANDARD_SETTER', officialPublicationRequired: true },
    { id: 'ICAN', name: 'Institute of Chartered Accountants of Nepal', authorityType: 'PROFESSIONAL_BODY', officialPublicationRequired: true },
    { id: 'FIU_NEPAL', name: 'Financial Intelligence Unit Nepal', authorityType: 'FINANCIAL_INTELLIGENCE', officialPublicationRequired: true },
]);
export const NEPAL_JURISDICTION_RULES = Object.freeze([
    {
        ruleId: 'nepal.calendar.fiscal-year',
        ruleVersion: '1.0.0',
        sourceAuthority: 'MINISTRY_OF_FINANCE_NEPAL',
        sourceDocumentId: 'authority.nepal.fiscal-calendar',
        module: 'calendar',
        effectiveFrom: '2000-01-01',
        implementationStatus: 'IMPLEMENTED',
    },
    {
        ruleId: 'nepal.calendar.bikram-sambat-display',
        ruleVersion: '1.0.0',
        sourceAuthority: 'NEPAL_LAW_COMMISSION',
        sourceDocumentId: 'authority.nepal.calendar-display',
        module: 'calendar',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.calendar.dual-date',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.market.nepse-instrument-identity',
        ruleVersion: '1.0.0',
        sourceAuthority: 'NEPSE',
        sourceDocumentId: 'authority.nepse.instrument-master',
        module: 'nepse',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.nepse.instrument',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.market.nepse-price-publication',
        ruleVersion: '1.0.0',
        sourceAuthority: 'NEPSE',
        sourceDocumentId: 'authority.nepse.market-data',
        module: 'nepse',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.nepse.market-price',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.depository.boid-privacy',
        ruleVersion: '1.0.0',
        sourceAuthority: 'CDSC',
        sourceDocumentId: 'authority.cdsc.boid',
        module: 'cdsc',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.cdsc.boid',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.depository.position-reconciliation',
        ruleVersion: '1.0.0',
        sourceAuthority: 'CDSC',
        sourceDocumentId: 'authority.cdsc.position-and-settlement',
        module: 'cdsc',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.cdsc.position-reconciliation',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.regulatory.sebon-portfolio-manager-reporting',
        ruleVersion: '1.0.0',
        sourceAuthority: 'SEBON',
        sourceDocumentId: 'authority.sebon.portfolio-manager-reporting',
        module: 'sebon',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.sebon.portfolio-manager-report',
        approvalPolicyId: 'approval.nepal.sebon.regulatory-filing',
        implementationStatus: 'IMPLEMENTED',
    },
    {
        ruleId: 'nepal.tax.securities-capital-gains',
        ruleVersion: '1.0.0',
        sourceAuthority: 'INLAND_REVENUE_DEPARTMENT_NEPAL',
        sourceDocumentId: 'authority.nepal.tax.securities-capital-gains',
        module: 'tax',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.tax.securities-capital-gains',
        validationSchemaId: 'schema.nepal.tax.securities-disposal',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.tax.securities-withholding',
        ruleVersion: '1.0.0',
        sourceAuthority: 'INLAND_REVENUE_DEPARTMENT_NEPAL',
        sourceDocumentId: 'authority.nepal.tax.securities-withholding',
        module: 'tax',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.tax.securities-withholding',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.accounting.nfrs-financial-instruments',
        ruleVersion: '1.0.0',
        sourceAuthority: 'ACCOUNTING_STANDARDS_BOARD_NEPAL',
        sourceDocumentId: 'authority.nepal.nfrs.financial-instruments',
        module: 'nfrs',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.nfrs.financial-instruments',
        implementationStatus: 'PARTIAL',
    },
    {
        ruleId: 'nepal.accounting.nfrs-fair-value',
        ruleVersion: '1.0.0',
        sourceAuthority: 'ACCOUNTING_STANDARDS_BOARD_NEPAL',
        sourceDocumentId: 'authority.nepal.nfrs.fair-value',
        module: 'nfrs',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.nfrs.fair-value',
        implementationStatus: 'PLANNED',
    },
    {
        ruleId: 'nepal.accounting.nfrs-expected-credit-loss',
        ruleVersion: '1.0.0',
        sourceAuthority: 'ACCOUNTING_STANDARDS_BOARD_NEPAL',
        sourceDocumentId: 'authority.nepal.nfrs.impairment',
        module: 'nfrs',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.nfrs9.expected-credit-loss',
        validationSchemaId: 'schema.nepal.nfrs9.ecl-staging',
        implementationStatus: 'PLANNED',
    },
    {
        ruleId: 'nepal.accounting.nfrs-financial-instrument-disclosures',
        ruleVersion: '1.0.0',
        sourceAuthority: 'ACCOUNTING_STANDARDS_BOARD_NEPAL',
        sourceDocumentId: 'authority.nepal.nfrs.disclosures',
        module: 'nfrs',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.nfrs7.disclosures',
        validationSchemaId: 'schema.nepal.nfrs7.disclosure-pack',
        implementationStatus: 'PLANNED',
    },
    {
        ruleId: 'nepal.aml.customer-due-diligence',
        ruleVersion: '1.0.0',
        sourceAuthority: 'FIU_NEPAL',
        sourceDocumentId: 'authority.nepal.aml.customer-due-diligence',
        module: 'aml',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.aml.customer-due-diligence',
        approvalPolicyId: 'approval.nepal.aml.case-submission',
        implementationStatus: 'PLANNED',
    },
    {
        ruleId: 'nepal.aml.suspicious-transaction-reporting',
        ruleVersion: '1.0.0',
        sourceAuthority: 'FIU_NEPAL',
        sourceDocumentId: 'authority.nepal.aml.suspicious-transaction-reporting',
        module: 'aml',
        effectiveFrom: '2000-01-01',
        validationSchemaId: 'schema.nepal.aml.suspicious-transaction-case',
        approvalPolicyId: 'approval.nepal.aml.regulatory-submission',
        implementationStatus: 'PLANNED',
    },
    {
        ruleId: 'nepal.mutual-fund.nav-calculation',
        ruleVersion: '1.0.0',
        sourceAuthority: 'SEBON',
        sourceDocumentId: 'authority.sebon.mutual-fund-nav',
        module: 'mutual-funds',
        effectiveFrom: '2000-01-01',
        calculationPolicyId: 'policy.nepal.mutual-fund.nav',
        validationSchemaId: 'schema.nepal.mutual-fund.nav',
        implementationStatus: 'PLANNED',
    },
]);
export function validateNepalJurisdictionRegistry() {
    const errors = [];
    const authorityIds = new Set(NEPAL_SOURCE_AUTHORITIES.map((authority) => authority.id));
    const ruleKeys = new Set();
    for (const rule of NEPAL_JURISDICTION_RULES) {
        if (!authorityIds.has(rule.sourceAuthority))
            errors.push(`unknown source authority ${rule.sourceAuthority}`);
        if (!rule.sourceDocumentId.trim())
            errors.push(`sourceDocumentId is required for ${rule.ruleId}`);
        const key = `${rule.ruleId}@${rule.ruleVersion}`;
        if (ruleKeys.has(key))
            errors.push(`duplicate rule version ${key}`);
        ruleKeys.add(key);
        if (rule.effectiveTo && rule.effectiveTo < rule.effectiveFrom)
            errors.push(`invalid effective period ${key}`);
    }
    return errors;
}
